import {TResetAll} from '../types';

export const createResetAllAction = (): TResetAll => {
  return {type: 'RESET', payload: {}};
};
